<script>
import simplebar from "simplebar-vue";
import vClickOutside from "v-click-outside";


import Message from "./message";

import { chatMemberList, chatMessages } from "./data";

const { detectMobile } = require("../../utils/mobileDetection");

export default {
  components: {
    simplebar,
    Message,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    username: {
       type: Object,
    },
    currentUserId: {
      type: [String, Number],
      required: true,
    },
    textMessages: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    rooms: {
      type: Array,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    messages: {
      type: Array,
      required: true,
    },
    roomMessage: {
      type: String,
    },

    textFormatting: {
      type: Boolean,
      required: true,
    },
    loadingRooms: {
      type: Boolean,
      required: true,
    },
    roomInfo: {
      type: Function,
    },
  },
  data() {
    return {
      postponeModal:false,
      chatMemberList: chatMemberList,
      chatMessages: chatMessages,
      message: "",
      messageReply: null,
      infiniteState: null,
      loadingMessages: false,
      loadingMoreMessages: false,
      file: null,
      imageFile: null,
      imageDimensions: null,
      menuOpened: false,
      emojiOpened: false,
      emojisList: {},
      hideOptions: true,
      scrollIcon: true,
      newMessages: [],
    };
  },
  mounted() {
    this.newMessages = [];
    window.addEventListener("keyup", (e) => {
      if (e.keyCode === 13 && !e.shiftKey) {
        if (detectMobile()) {
          this.message = this.message + "\n";
          setTimeout(() => this.onChangeInput(), 0);
        } else {
          this.sendMessage();
        }
      }
    });
  },
  watch: {
    loadingMessages(val) {
      if (val) this.infiniteState = null;
      else this.focusTextarea(true);
    },
    room(newVal, oldVal) {
      if (newVal.id && newVal.id !== oldVal.id) {
        this.loadingMessages = true;
        this.scrollIcon = false;
        this.resetMessage(true);
        if (this.roomMessage) {
          this.message = this.roomMessage;
          setTimeout(() => this.onChangeInput(), 0);
        }
      }
    },
    messages(newVal, oldVal) {
      const element = this.$refs.scrollContainer;
      if (!element) return;
      const options = {
        top: element.scrollHeight,
      };
      if (oldVal && newVal && oldVal.length === newVal.length - 1) {
        return setTimeout(() => {
          options.behavior = "smooth";
          element.scrollTo(options);
        }, 50);
      }
      if (this.infiniteState) {
        this.infiniteState.loaded();
        setTimeout(() => (this.loadingMoreMessages = false), 0);
      } else if (newVal.length) {
        setTimeout(() => {
          element.scrollTo(options);
          this.loadingMessages = false;
        }, 0);
      }
    },
  },
  computed: {

    room() {
      return this.chatMemberList.find((room) => room.id === this.id) || {};
    },
    inputDisabled() {
    
      return this.username.connected;
    },
  },
  methods: {
    ShowPostponeModal(){
       this.postponeModal = true 
    },
    addNewMessage(message) {
      console.log(message)
      this.newMessages.push(message);
      this.handleScroll();
    },
    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
    resetMessage(disableMobileFocus = null, editFile = null) {
      this.$emit("typingMessage", null);
      if (editFile) {
        this.file = null;
        this.message = "";
        return;
      }
      this.resetTextareaSize();
      this.message = "";
      this.messageReply = null;
      setTimeout(() => this.focusTextarea(disableMobileFocus), 0);
    },
    resetTextareaSize() {
      if (!this.$refs["roomTextarea"]) return;
      this.$refs["roomTextarea"].style.height = "20px";
    },
    focusTextarea(disableMobileFocus) {
      if (detectMobile() && disableMobileFocus) return;
      this.$refs["roomTextarea"].focus();
    },
    isMessageEmpty() {
      return !this.file && !this.message.trim();
    },
    sendMessage() {
      if (!this.file && !this.message.trim()) return;

        const currentDate = new Date();
        this.$emit("sendMessage", {
          content: this.message.trim(),
          replyMessage: this.messageReply,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
          align: "right",
        });

      this.resetMessage(true);
    },
    scrollToBottom() {
      const element = this.$refs.scrollContainer;
      element.scrollTo({
        top: element.scrollHeight,
        behavior: "smooth",
      });
    },
    disconnect() {
      this.$emit("disconnect")
      localStorage.removeItem("sessionID");
      localStorage.removeItem("username");
      localStorage.removeItem("phone");
    },
    onChangeInput() {
      this.resizeTextarea();
      this.$emit("typingMessage", this.message);
    },
    /**
     * Resize textarea
     */
    resizeTextarea() {
      const el = this.$refs["roomTextarea"];
      if (!el) return;
      const padding = window
        .getComputedStyle(el, null)
        .getPropertyValue("padding-top")
        .replace("px", "");
      el.style.height = 0;
      el.style.height = el.scrollHeight - padding * 2 + "px";
    },
    closeUserChat() {
      var userChat = document.getElementsByClassName("user-chat");
      if (userChat) {
        userChat[0].classList.remove("user-chat-show");
      }
    },
  },
};
</script>

<template>
  <div class="user-chat w-100 overflow-hidden">
    <div class="d-flex">
      <div class="w-100 overflow-hidden position-relative">
        <div class="p-3 p-lg-4 border-bottom">
          <div class="row align-items-center">
            <div class="col-6">
              <div class="media align-items-center">
                <div v-if="username.userID">
                  <h5 class="font-size-16 mb-0 ">
                    <a href="javascript:void(0);" class="text-reset user-profile-show imedil_h">{{username? username.username:""}}</a>
                    <i
                      class="ri-record-circle-fill font-size-10 text-success d-inline-block ml-1"
                      :class="{
                    'text-success': username.connected === true,
                    'text-warning': username.connected === false,
                  }"
                    ></i>  <img v-if="username.typing" src="@/assets/audio/type2.gif" height="40px">
                    </h5>
                </div>
              </div>
            </div>
            <div class="col-6">
              <ul class="list-inline user-chat-nav text-right mb-0">
                <li class="list-inline-item d-lg-inline-block pointer"  @click="disconnect">
                  გასვლა
                  <button
                   
                    type="button"
                    class="btn nav-btn"
                  >
                   <i class="ri-logout-circle-r-line "></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <simplebar
          class="chat-conversation p-3 p-lg-4"
          id="containerElement"
          ref="current"
        > 
        <div  v-if="!username.userID" class="text-right col-9 offset-2"><img src="@/assets/images/chat.gif" height="60px">  </div>
        <div v-if="!username.userID" class="alert alert-info text-center col-8 offset-2 mt-3" >ჩვენი კონსულტანტი მალე გიპასუხებს,<br> გთხოვ დაელოდო
        
        </div>
        
 
          <div v-for="(message, index) in messages" :key="index">
            <message
              :currentUserId="currentUserId"
              :message="message"
              :messages="chatMessages"
              :roomUsers="room.users"
              :textMessages="textMessages"
              :roomFooterRef="$refs.roomFooter"
              :newMessages="newMessages"
              :textFormatting="textFormatting"
              :hideOptions="hideOptions"
              @addNewMessage="addNewMessage"
              @hideOptions="hideOptions = $event"
            ></message>
           
          </div>
        
            <!-- <div style="clear:both" v-if="username.userID?username.typing:false">
             <img src="@/assets/images/typeing.gif" height="50px">
            </div> -->
        </simplebar>

        <div ref="roomFooter" class="room-footer" v-if="username.userID">
        

          <div class="box-footer chat-input-section p-3 p-lg-4 border-top mb-0">
            <div class="image-container" >
              <div class="svg-button icon-image">
                
              </div>

            </div>


            <textarea v-if="this.username.connected"
          
              ref="roomTextarea"
              :placeholder="textMessages.TYPE_MESSAGE"
              :style="{
                'min-height': `${
                  imageDimensions ? imageDimensions.height : 20
                }px`,
                'padding-left': `${
                  imageDimensions ? imageDimensions.width - 10 : 12
                }px`,
              }"
              class="form-control form-control-lg bg-light border-light rounded textareaClass"
              v-model="message"
              @input="onChangeInput"
              @keydown.esc="resetMessage"
              @keydown.enter.exact.prevent
            ></textarea>

            <div class="icon-textarea">


        
              <div v-if="this.username.connected">
                <button
                  type="submit"
                  class="btn btn-info font-size-16 btn-lg chat-send"
                  @click="sendMessage"
                  :class="{ 'send-disabled': !inputDisabled }"
                >
                  <i
                    class="ri-send-plane-2-fill"
                    :param="!inputDisabled ? 'disabled' : ''"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

        <!-- audiocall Modal -->
        <b-modal id="audiocallModal" v-model="postponeModal" centered hide-header hide-footer>
                  <div class="text-center p-4">
                    <div class="avatar-lg mx-auto mb-4">
                      <img
                        src="../../../assets/images/users/avatar-4.jpg"
                        alt=""
                        class="img-thumbnail rounded-circle"
                      />
                    </div>

                    <h5 class="text-truncate">Doris Brown</h5>
                    <p class="text-muted">Start Audio Call</p>

                    <div class="mt-5">
                      <ul class="list-inline mb-1">
                        <li class="list-inline-item px-2">
                          <button
                            type="button"
                            class="btn btn-danger avatar-sm rounded-circle"
                            data-dismiss="modal"
                            @click="$bvModal.hide('audiocallModal')"
                          >
                            <span
                              class="avatar-title bg-transparent font-size-20"
                            >
                              <i class="ri-close-fill"></i>
                            </span>
                          </button>
                        </li>
                        <li class="list-inline-item px-2">
                          <button
                            type="button"
                            class="btn btn-success avatar-sm rounded-circle"
                          >
                            <span
                              class="avatar-title bg-transparent font-size-20"
                            >
                              <i class="ri-phone-fill"></i>
                            </span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
        </b-modal>
        <!-- audiocall Modal -->
  </div>

  
</template>

<style lang="scss" scoped>
.messages-container {
  padding: 0 5px 5px;
}

.room-footer {
  width: calc(100% - 1px);
  border-bottom-right-radius: 4px;
  z-index: 10;
}

.box-footer {
  display: flex;
  position: relative;
  background: var(--chat-footer-bg-color);
  padding: 10px 8px 10px;
}

.reply-container {
  display: flex;
  padding: 10px 10px 0 10px;
  background: var(--chat-content-bg-color);
  align-items: center;
  max-width: 100%;

  .reply-box {
    width: 100%;
    overflow: hidden;
    background: var(--chat-footer-bg-color-reply);
    border-radius: 4px;
    padding: 8px 10px;
    display: flex;
  }

  .reply-info {
    overflow: hidden;
  }

  .reply-username {
    color: var(--chat-message-color-reply-username);
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 2px;
  }

  .reply-content {
    font-size: 12px;
    color: var(--chat-message-color-reply-content);
  }

  .icon-reply {
    margin-left: 10px;

    svg {
      height: 20px;
      width: 20px;
    }
  }

  .image-reply {
    max-height: 100px;
    margin-right: 10px;
  }
}

textarea {
  height: 20px;
  width: 100%;
  line-height: 20px;
  overflow: hidden;
  outline: 0;
  resize: none;
  border-radius: 20px;
  padding: 12px 16px;
  box-sizing: content-box;
  font-size: 16px;
  background: var(--chat-bg-color-input);
  color: var(--chat-color);
  caret-color: var(--chat-color-caret);
  border: var(--chat-border-style-input);

  &::placeholder {
    color: var(--chat-color-placeholder);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.icon-textarea {
  display: flex;
  margin: 0px 0 0 5px;

  svg,
  .wrapper {
    margin: 0 7px;
  }
}

.image-container {
  position: absolute;
  max-width: 25%;
  left: 25px;
  top: 4px;
}

.image-file {
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 30px;

  img {
    border-radius: 7px;
    width: 100%;
    max-width: 150px;
    max-height: 100%;
    margin: 12px 0 0 12px;
  }
}

.icon-image {
  position: absolute;
  z-index: 10;
}

.file-container {
  display: flex;
  align-items: center;
  width: calc(100% - 75px);
  height: 20px;
  padding: 12px 0;
  box-sizing: content-box;
  background: var(--chat-bg-color-input);
  border: var(--chat-border-style-input);
  border-radius: 20px;
}

.file-container-edit {
  width: calc(100% - 109px);
}

.file-message {
  max-width: calc(100% - 75px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-file {
  display: flex;
  margin: 0 8px 0 15px;
}

.icon-remove {
  margin-left: 8px;

  svg {
    height: 18px;
    width: 18px;
  }
}

.send-disabled,
.send-disabled svg {
  cursor: none !important;
  pointer-events: none !important;
  transform: none !important;
}

.messages-hidden {
  opacity: 0;
}

@media only screen and (max-width: 768px) {
  .box-footer {
    border-top: var(--chat-border-style-input);
    padding: 7px 2px 7px 7px;
  }

  textarea {
    padding: 7px;
    line-height: 18px;

    &::placeholder {
      color: transparent;
    }
  }

  .icon-textarea {
    margin: 6px 0 0 5px;

    svg,
    .wrapper {
      margin: 0 5px;
    }
  }

  .image-container {
    top: 10px;
    left: 10px;
  }

  .image-file img {
    transform: scale(0.97);
  }

  .room-footer {
    width: 100%;
  }

  .file-container {
    padding: 7px 0;

    .icon-file {
      margin-left: 10px;
    }
  }

  .reply-container {
    padding: 5px 8px;
  }
}
</style>
